import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { navLinks, contactEmail, websiteUrl } from '../data/navigation';
import { services } from '../data/services';
const linkClass = 'text-sm text-white/70 transition-colors duration-150 ease-out hover:text-gold focus-visible:outline-none focus-visible:text-gold';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-navy text-white" data-id="element-131" data-mp="3ugbqj7nstejc">
      <div className="mx-auto max-w-7xl px-6 pb-10 pt-20 lg:px-10" data-id="element-132" data-mp="38qvoyiyxrr6">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12" data-id="element-133" data-mp="37xyao5wgelp">
          <div className="lg:col-span-4" data-id="element-134" data-mp="3ldamrdmenziu">
            <Logo tone="light" data-id="element-135" data-mp="3lggb2qn7mxdi" />
            <p className="mt-6 max-w-sm font-serif text-xl leading-snug text-white/80" data-id="element-136" data-mp="3qcxbokblj47h">
              Connecting exceptional talent with organizations that need the right leaders.
            </p>
          </div>

          <nav aria-label="Footer" className="lg:col-span-3" data-id="element-137" data-mp="2eyjrbpg1x6w7">
            <h2 className="text-sm font-medium text-gold" data-id="element-138" data-mp="2evxb71f3hj2d">Navigation</h2>
            <ul className="mt-5 space-y-3" data-id="element-139" data-mp="3l9sjf6xt4wpj">
              {navLinks.map(link => <li key={link.to} data-id="element-140" data-mp="3gbqx8d534h9u">
                  <Link to={link.to} className={linkClass} data-id="element-141" data-mp="3gctr8txpeztz">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-2" data-id="element-142" data-mp="3qapz9cvchenv">
            <h2 className="text-sm font-medium text-gold" data-id="element-143" data-mp="82ibxqv2w6ds">Services</h2>
            <ul className="mt-5 space-y-3" data-id="element-144" data-mp="80nvopur52g1">
              {services.map(s => <li key={s.title} data-id="element-145" data-mp="31uo1e25c5ns">
                  <Link to="/services" className={linkClass} data-id="element-146" data-mp="htd1b43mfm3g">
                    {s.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-3" data-id="element-147" data-mp="qthzcnmxd84y">
            <h2 className="text-sm font-medium text-gold" data-id="element-148" data-mp="qub8fv9cw9q9">Contact</h2>
            <ul className="mt-5 space-y-3" data-id="element-149" data-mp="msg7irvc7yd0">
              <li data-id="element-150" data-mp="mthh0rwpgcsm">
                <a href={`mailto:${contactEmail}`} className={`${linkClass} break-all`} data-id="element-151" data-mp="mptsk764agkr">
                  {contactEmail}
                </a>
              </li>
              <li data-id="element-152" data-mp="yuzcs1ddblny">
                <a href={websiteUrl} className={linkClass} data-id="element-153" data-mp="yuh7ygcn3z4f">
                  risingtalentpartners.com
                </a>
              </li>
              <li data-id="element-154" data-mp="18jr0tyfb5ltl">
                <Link to="/employers#enquiry" className={linkClass} data-id="element-155" data-mp="18k93bcskcw9y">
                  Employer enquiry form
                </Link>
              </li>
              <li data-id="element-156" data-mp="1cnoye4oziokj">
                <Link to="/candidates#register" className={linkClass} data-id="element-157" data-mp="1hkp58htnrvcp">
                  Register your interest
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-white/60 sm:flex-row sm:justify-between" data-id="element-158" data-mp="1riv4ssrzspee">
          <p data-id="element-159" data-mp="3oc6sl2g3h81m">© {year} Rising Talent Partners. All rights reserved.</p>
          <a href={websiteUrl} className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-160" data-mp="3t9yi5pt9oi2n">
            risingtalentpartners.com
          </a>
        </div>
      </div>
    </footer>;
}